import { render, staticRenderFns } from "./ConcernDetailModal.vue?vue&type=template&id=264b344c&scoped=true"
import script from "./ConcernDetailModal.vue?vue&type=script&lang=js"
export * from "./ConcernDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ConcernDetailModal.vue?vue&type=style&index=0&id=264b344c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b344c",
  null
  
)

export default component.exports